<div class="drawer-mobile-close">
  <button type="button" nz-button nzType="text" class="drawer-close-btn app-icon-button" (click)="close()" aria-label="{{ 'common.actions.close' | translate }}" nzShape="circle">
    <nz-icon nzType="close" aria-hidden="true"></nz-icon>
  </button>
  <div class="drawer-mobile-close__body">
    <ng-content></ng-content>
  </div>
</div>
